import { ReactNode } from 'react';
import YotpoStarRatings from 'components/YotpoStarRatings';
import Carousel from 'components/emblaCarousel';

export type Testimonial = {
  quote: string;
  attribution: string;
};

type TestimonialsProps = {
  heading: string;
  items: Testimonial[];
  cta?: ReactNode;
};

const testimonialSliderOptions = {
  slidesToScroll: 1,
} as const;

export const Testimonials = ({ heading, items, cta }: TestimonialsProps) => {
  return (
    <div className="bg-gold-lighter">
      <div className="container p-32">
        <div className="my-32 flex flex-col items-center justify-between gap-y-16">
          <h2 className="text-center font-condensed text-[20px] uppercase leading-relaxed tracking-wide text-gray-darker">{heading}</h2>

          <YotpoStarRatings alignment="center" showCountOnNewLine />
        </div>

        <div className="row hidden md:grid">
          {items.map((testimonial, index) => (
            <div key={`desktop-testimonial-${index}`} className="col-span-4 flex h-full flex-col justify-between gap-y-16 text-gray-darker">
              <p className="font-display text-[23px] leading-relaxed lg:text-[26px]">&#x201C;{testimonial.quote}&#x201D;</p>

              <p>&mdash; {testimonial.attribution}</p>
            </div>
          ))}
        </div>

        <div className="block md:hidden">
          <Carousel className="flex" options={testimonialSliderOptions} showPagination>
            {items.map((testimonial, index) => (
              <div
                key={`mobile-testimonial-${index}`}
                className="col-span-4 flex h-full flex-col justify-between gap-y-16 text-gray-darker"
                style={{ flex: '0 0 100%' }}
              >
                <p className="font-display text-[23px] leading-relaxed lg:text-[26px]">&#x201C;{testimonial.quote}&#x201D;</p>

                <p>&mdash; {testimonial.attribution}</p>
              </div>
            ))}
          </Carousel>
        </div>

        {cta && <div className="mt-64 mb-32 flex flex-col items-center">{cta}</div>}
      </div>
    </div>
  );
};
